import React, { SetStateAction } from "react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Eye, EyeOff } from "lucide-react";

interface Props {
  label?: string;
  placeholder?: string;
  value: string;
  setValue: React.Dispatch<SetStateAction<string>>;
  readOnly?: boolean;
}

function PasswordInput({
  label,
  placeholder,
  value,
  setValue,
  readOnly,
}: Props) {
  const [isHidden, setIsHidden] = React.useState<boolean>(true);
  const handleHidden = () => {
    setIsHidden(!isHidden);
  };
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label>{label}</Label>
      <div className="relative">
        {!isHidden ? (
          <Eye
            onClick={handleHidden}
            className="bg-white cursor-pointer absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500"
          />
        ) : (
          <EyeOff
            onClick={handleHidden}
            className="bg-white cursor-pointer absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500"
          />
        )}
        <Input
          placeholder={placeholder}
          type={isHidden ? "password" : "text"}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          readOnly={readOnly ?? false}
        />
      </div>
    </div>
  );
}

export default PasswordInput;
